export default __webpack_public_path__ + "static/media/oscer-pres-vision-loss.ee511564.svg";